export class ScoreTop {
    last_top: ScoreData = new ScoreData();
    datas: ScoreData[] = [];
}

export class ScoreData {
    order: number = 0;
    user_id: string = "";
    user_name: string = "";
    score: number = 0;
}

export class TimeTop {
    last_top: TimeData = new TimeData();
    datas: TimeData[] = [];
}

export class TimeData {
    order: number = 0;
    user_id: string = "";
    user_name: string = "";
    used_time: string = "";
}
